import "../styles/header.scss";

export default function Banner (props) {

    return (
        <div className="banner">
            <p>Githunguri Water and Sanitation Company Ltd.</p>
        </div>         
    );
}